export const dataDefault = [{
    sort: 0,
    name: "Accounting",
    risks: "23",
    file: "",
    control: "",
}, {
    sort: 1,
    name: "0",
    risks: `Cash Audit	 once per week performed by someone other than General Cashier. Forwarded to
    DOF once per week.  Cash Flow should be as the same as System. Discrepancies are 
    documented	 and followed up on promptly.<br/>
    总出纳备用金应每周由非总出纳人员参与检查一次 ，将结果抄送财务总监。现金流应与系统记录一
    致。所有差异应正确记录并立即跟进 。
    `,
    file: "总出纳现金盘点表",
    control: "",
}, {
    sort: 2,
    name: "0",
    risks: `Bank audits	 performed by General Cashier and another hotel associate each month 
    Discrepancies are documented and followed up on promptly.  All bank reconciliations 
    completed once per month and approved by DOF.  All reconciliations should be completed
    within 10 days.<br/>
    银行账户审查应由总出纳和其他员工每月进行一次	，所有差异应正确记录并跟进。所有银行余额调
    节表需每月完成	，并交财务总监审阅。所有的调节项目应在月初十日内完成。
    `,
    file: "银行余额调节表",
    control: "",
}, {
    sort: 3,
    name: "0",
    risks: `Rebates, discounts,	 complimentary, entertainment, duty meal audited and forwarded to 
    DOF/GM. And	 reviewed in the monthly P&L Meeting.<br/>
    抵减，折扣	，免费，宴请，内部账单，等收入减项需每月制作汇总表，交由财务总监，总经理审 
    阅，并在每月损益会上审阅 。
    `,
    file: "收入减项月度汇总表",
    control: "",
}, {
    sort: 4,
    name: "0",
    risks: `All local and Country tax regulations are properly administered. Tax payments are made timely 
    and in accordance with local laws.<br/>
    所有国家和当地的税务法规应正确实施	。每月应按照法律法规及时缴纳各种税费。
    `,
    file: "",
    control: "",
}, {
    sort: 5,
    name: "0",
    risks: `Guest Ledger to City Ledger Tracking in place to determine number of days to produce and
    send a bill. Transfer to City Ledger takes less than 3 days. Cycle time, including issuing a bill, 
    is six days or less.<br/>
    客账转城市挂账的转移应及时跟进	，并在3日内完成。在最多6日内完成内部审批，寄出账单。
    `,
    file: "当日假房清单",
    control: "",
}, {
    sort: 6,
    name: "0",
    risks: `DCSO (days of credit sales outstanding) tracking mechanism in place to monitor weekly and 
    monthly collection results. A/R aging report reviewed weekly by A/R supervisor and monthly by 
    DOF.<br/>
    应收账款账龄分析应在每周和每月进行总结。账龄分析表应在每周交由应收主管审阅，每月由财务 
    总监审阅。
    `,
    file: "应收账款账龄表",
    control: "",
}, {
    sort: 7,
    name: "0",
    risks: `A/R Supervisor forwards weekly recap of all incoming credit decision to sales, catering, for the 
    next 30-45 days.  A/R supervises daily balances of in house groups to ensure credit limits are 
    not exceeded. Credit Meeting and Meeting Minutes should be taken each month and recorded. <br/>
    应收主管应每周制作应收账款分析表，并确认客户的权限未超出额度和收款时限。信贷会议应在最 
    少每月召开一次并有会议记录。 
    `,
    file: "连续三次的信贷会议纪要",
    control: "",
}, {
    sort: 8,
    name: "0",
    risks: `A/R accounts for Airline crews, wholesalers, Wyndham rewards, and credit cards are 
    reconciled. Any non-current balances in these accounts have documented collection efforts 
    underway.<br/>
    针对机组，旅行社、温德姆积分计划、信用卡等的应收账户应及时更新。如有历史问题，应及时追 
    收解决，相关文件应归档。
    `,
    file: "积分计划会员列表前30位",
    control: "",
}, {
    sort: 9,
    name: "0",
    risks: `Credit card refunds charge back are restricted to non A/R clerk.  The GM and DOF approves  
    monthly refunds and charge-back reconciliation.<br/>
    信用卡退款业务必须经由应收账款文员操作，财务总监和总经理对每月的退款进行审批。
    `,
    file: "信用卡退款实例现金支付实例",
    control: "",
}, {
    sort: 10,
    name: "0",
    risks: `Complete reconciliation of all checks written, voided, destroyed, stored, and lost is maintained 
    by Accounts Payable.<br/>
    所有支票的填写，无效，作废，保存，丢失的记录均应由应付账款负责。
    `,
    file: "支票记录表",
    control: "",
}, {
    sort: 11,
    name: "0",
    risks: `Howard Johnson Inter-Company billings are posted and paid on a timely basis. Wire transfer 
    payments are properly processed and there are no unapplied payment amounts on the 
    Corporate A/R aging report.<br/>
    及时记录和支付集团酒店之间的帐目 , 正确处理电汇 , 并确保按时支付总部的款项。
    `,
    file: "未支付总部款项清单",
    control: "",
}, {
    sort: 12,
    name: "0",
    risks: `Balance sheet reconciliations are completed and approved by the DOF/General Manager in
    accordance with Corporate policy.  Exception is followed up and resolved where applicable and
    repeat issues are minimized.<br/>
    资产负债表调节应每月完成，并交由财务总监、总经理审阅。所有调整项应及时调整，减少重复性 
    问题。
    `,
    file: "资产负债表调节表",
    control: "",
}, {
    sort: 13,
    name: "0",
    risks: `Cash Flow Projection Analysis reviewed by DOF/GM each month.  Analysis comparing actual 
    balances with standards are reviewed.  Actions taken to resolve significant variations are 
    documented.<br/>
    现金流量预测分析应每月由财务总监和总经理审阅。应有具体的行动计划解决重要的差异并备案。
    `,
    file: "现金流量月度分析",
    control: "",
}, {
    sort: 14,
    name: "0",
    risks: `Inventory stock taken is finished properly monthly. All the results should be followed. Slow 
    moving items list should be reviewed by management. <br/>
    存货盘点应每月正确完成。盘盈盘亏的结果应及时跟进。滞销品项目清单应由管理层审阅。
    `,
    file: "存货盘点清单，以及跟进报告，滞销品清单",
    control: "",
}, {
    sort: 15,
    name: "0",
    risks: `Procurement policy is established at the hotel.  Policy hi-lights approval level required for 
    purchase orders and bid requirements.  A segregation of duty exists between purchasing and
    receiving.<br/>
    采购政策应建立，对于采购订单的审批和招标要求应重点跟进。采购和收货的权责分离应明确。
    `,
    file: "采购制度",
    control: "",
}, {
    sort: 16,
    name: "0",
    risks: `Expenses reports audited by DOF and approved by General Manager.<br/>
    费用报告应由财务总监审阅，并由总经理审批。
    `,
    file: "费用报告",
    control: "",
}, {
    sort: 17,
    name: "0",
    risks: `Contracts, Permits, Licenses, and Insurance certificates maintained and expiration listing 
    reviewed on a quarterly basis by DOF and General Manager.<br/>
    合同，许可证，执照以及保险合同，应归档。并建立期限清单每季度交由财务总监和总经理审阅。
    `,
    file: "文件资料归档清单",
    control: "",
}, {
    sort: 18,
    name: "0",
    risks: `Appropriate segregation of duties exists for the preparation, review, and approval of all journal 
    vouchers prior to their being posted into accounting system.<br/>
    对于会计凭证的编辑、检查和审批，应有合适的权责分离。
    `,
    file: "最近一月财务凭证审查",
    control: "",
}, {
    sort: 19,
    name: "0",
    risks: `Shopping audits in place twice a year.<br/>神秘访客应每半年安排一次。`,
    file: "最近一次神秘访客报告",
    control: "",
}, {
    sort: 20,
    name: "0",
    risks: `Follow the guideline of Operating Equipments Accounting Treatment. Do the physical  
    inspection on quarter basis and analysis on the consumption.<br/>
    执行营运工具会计处理，每季度进行实物盘点并跟进分析。
    `,
    file: "最近一期的营运工具盘点分析报告",
    control: "",
}, {
    sort: 21,
    name: "0",
    risks: `The policy of Owner's discount is accomplished according to the Standard Operating 
    Procedure.<br/>
    严格遵守SOP中业主折扣的规定。
    `,
    file: "业主消费的会计凭证",
    control: "",
}, {
    sort: 22,
    name: "0",
    risks: `The vacation and overtime are recorded properly. <br/>
    假期和加班应正确记录。
    `,
    file: "假期和加班的会计凭证",
    control: "",
}, {
    sort: 23,
    name: "0",
    risks: `Year End Bonus provision are accrued and adjusted according to the Standard Operating  
    Procedure.<br/>
    年度奖金预提和调整应根据标准操作流程执行。
    `,
    file: "奖金预提会计凭证",
    control: "",
}, {
    sort: 24,
    name: "Sales & Marketing",
    risks: `1`,
    file: "",
    control: "",
}, {
    sort: 25,
    name: "0",
    risks: `Three-month rolling forecast is prepared and reviewed. Segment breakout need dates hi-
    lighted for pricing and promotional opportunities every month.  Group booking pace reviewed at 
    forecast meeting.  Forecast accuracy reviewed in every forecast meeting.<br/>
    编辑和审阅酒店3个月的收入预测报告。市场分割应注明每月进行价格调整和促销的特定日期。团 
    队预定情况应在预测会议中审阅。 在收入预测会议中应审阅整体预测的准确性。
    `,
    file: "收入预测报告",
    control: "",
}, {
    sort: 26,
    name: "Rooms",
    risks: `5`,
    file: "",
    control: "",
}, {
    sort: 27,
    name: "0",
    risks: `Rooms Revenue Audit performed by General Manager (designated person) against a room
    revenue policy.  Comps, Rebates and write -offs reviewed and approved appropriately; include 
    evidence of review.<br/>
    总经理 ( 或指派他人 ) 每日检查客房收入。并检查包括 免费房 , 房价减免及取消的审批 , 及书面批示。
    `,
    file: "",
    control: "",
}, {
    sort: 28,
    name: "0",
    risks: `Market codes and rates are reviewed according to sale strategy.<br/>
    根据销售计划检查市场代码和房价
    `,
    file: "",
    control: "",
}, {
    sort: 29,
    name: "0",
    risks: `Rate changes and upgrades reviewed daily by DOR.<br/>
    房务总监每日检查房价变更和升级
    `,
    file: "",
    control: "",
}, {
    sort: 30,
    name: "0",
    risks: `Top Wyndham report is reviewed and signed by the General Manager and all Executive 
    Committee members to indicate that all individuals listed on the report are identified as VIPs.
    总经理审阅并签批温德姆客人汇总报表，其中的散客名单，经行政委员会成员商讨后，可将作为酒<br/>
    店的重要客人。
    `,
    file: "温德姆客人汇总报表",
    control: "",
}, {
    sort: 31,
    name: "0",
    risks: `Housekeeping Discrepancy report.  Housekeeping and Front Office to prepare daily  
    discrepancy report.  Reports for week to be forwarded to General Manager and DOF weekly. <br/>
    客房部与前台每日上报客房差异报告，每周呈送 总经理和财务总监审阅。
    `,
    file: "客房差异报告",
    control: "",
}, {
    sort: 32,
    name: "Food and Beverage",
    risks: `11`,
    file: "",
    control: "",
}, {
    sort: 33,
    name: "0",
    risks: `Key food and beverage revenue controls in place and audited daily by Accounting.  Open Food /  
    Beverage, void & cancel, and discount control reviewed by management.<br/>
    财务部每日审计餐饮收入。开价食品/酒水，菜品取消及菜单整张取消应由管理层审核。
    `,
    file: "",
    control: "",
}, {
    sort: 34,
    name: "0",
    risks: `All package pricing is correctly programmed in PMS (property management system) to fairly
    allocate revenues to appropriate outlets. Outlet postings of actual customer usage is properly 
    recorded and routinely audited for accuracy. Breakage is analyzed and package pricing and 
    allocation reviewed accordingly. <br/>
    所有套餐售价应正确输入管理系统，以便合理分配部门收入。 正确记录并准确检查客人在营业场 
    所的实际消费，检查整体包价和收入分配。
    `,
    file: "",
    control: "",
}, {
    sort: 35,
    name: "0",
    risks: `Outlet cashier and bartender surprise audits completed monthly. <br/>
    餐厅的收银员和吧员应每月做一次未通知检查。
    `,
    file: "检查报告",
    control: "",
}, {
    sort: 36,
    name: "0",
    risks: `Event Order should be audited by cost control at advance. Banquet checks are audited nightly 
    to BEO's (banquet event orders), daily event sheet, and Group Master instructions. <br/>
    成本部应事先对宴会预订单进行成本分析。宴会账单，预订单以及团队账单应及时审核。
    `,
    file: "",
    control: "",
}, {
    sort: 37,
    name: "0",
    risks: `Beverage Perpetual inventory is audited on a monthly basis and results compared to actual 
    once per month.<br/>
    饮品存货应每月盘点，并账实相符。
    `,
    file: "",
    control: "",
}, {
    sort: 38,
    name: "0",
    risks: `Banquet Beverage controls are documented and in place.  Banquet  bar requisitions are 
    completed for each banquet bar.  Deposit drop procedures are posted and adhered to. <br/>
    宴会酒水使用和控制应记录存档，宴会酒水提货单要结合宴会预订单，记录并跟踪其付款方式。
    `,
    file: "食品饮品成本分析报告",
    control: "",
}, {
    sort: 39,
    name: "0",
    risks: `Food and Beverage cost should be reviewed and taken action monthly.<br/>
    食品饮品成本应每月审阅并跟进。
    `,
    file: "",
    control: "",
}, {
    sort: 40,
    name: "0",
    risks: `Food sanitation audit performed by Sr. Food and Beverage Manager monthly and copied to 
    General Manager.  HRD should be responsible for the staffs' canteen sanitation audit. HCTTP
    should be covered in the training and recorded. <br/>
    食品卫生应每月由餐饮总监检查，并书面报告总经理。人力资源总监应对员工餐厅的食品卫生负责 
    。HACCP应定期培训，并有参与培训人员签字。
    `,
    file: "食品卫生检查报告HACCP培训签到表",
    control: "",
}, {
    sort: 41,
    name: "0",
    risks: `Food and Beverage Cost are recorded on the Matching Principle. <br/>
    食品饮品成本应严格按照配比原则记录。
    `,
    file: "",
    control: "",
}, {
    sort: 42,
    name: "0",
    risks: `Hotel package and breakfast are allocated properly among the related departments.<br/>
    酒店包价和早餐应在相关部门间合理分配。
    `,
    file: "",
    control: "",
}, {
    sort: 43,
    name: "0",
    risks: `Check and review the quality of the suppliers, and make sure the quality could be reached the 
    VAT requirements, and could be share the VAT benefits. <br/>
    检查供应商资质，确保供应商资质符合增值税开票要求，并享受增值税改革福利。
    `,
    file: "",
    control: "",
}, {
    sort: 44,
    name: "Human Resources",
    risks: `5`,
    file: "",
    control: "",
}, {
    sort: 45,
    name: "0",
    risks: `All adjustments to payroll registers, timesheets, and rates of pay are properly calculated, 
    approved, and supported by written documentation.  Appropriate segregation of duties exists
    between payroll processing and payroll administration.<br/>
    所有工资记录 , 考勤表 , 工资金额的调整 , 必须正确计算 , 审批且后附书面报告 , 合理分工工资计算 
    和工资监管的责任。
    `,
    file: "出勤记录表",
    control: "",
}, {
    sort: 46,
    name: "0",
    risks: `Labor cost action plan and target reviewed, manning guide reviewed each quarter.<br/>
    人力成本应有具体的跟进计划和方案。人员岗位安排应每季度审阅一次。
    `,
    file: "人力成本跟进方案",
    control: "",
}, {
    sort: 47,
    name: "0",
    risks: `Duty Roster should be reviewed monthly.<br/>
    岗位排班表应每月审阅一次。
    `,
    file: "岗位排班表",
    control: "",
}, {
    sort: 48,
    name: "0",
    risks: `OT and annual leave should be reviewed monthly and recorded properly.<br/>
    加班和年假需要每月审阅一次，并合理正确记录。
    `,
    file: "加班记录表，年假清单",
    control: "",
}, {
    sort: 49,
    name: "0",
    risks: `Job description for all associates and managers assigned to cash handling and revenue 
    recording tasks are updated and signed by associates. <br/>
    所有涉及持有现金和收入记录的员工和经理人员，应具备岗位工作职责并且签字。 
    `,
    file: "岗位职责",
    control: "",
}, {
    sort: 50,
    name: "Engineering",
    risks: `3`,
    file: "",
    control: "",
}, {
    sort: 51,
    name: "0",
    risks: `Engineering completes period preventive maintenance on major mechanical equipment  
    (boilers, chillers, pumps, hot water heaters).  All preventive maintenance is fully documented.<br/>
    工程部要完善对主要机器设备的预防性定期维修 - 包括 锅炉，冷库，水泵，热水器 等。 所有定期 
    维修要全部存档。
    `,
    file: "工程定期维修表",
    control: "",
}, {
    sort: 52,
    name: "0",
    risks: `Energy cost saving should be taken place on a monthly basis. The meeting minutes should be 
    filed. <br/>
    节能会议每月召开，且节能方案应跟进实施，会议纪要应归档。
    `,
    file: "节能方案连续三次节能会议纪要",
    control: "",
}, {
    sort: 53,
    name: "0",
    risks: `Engineering and Security Department completes fire drills as frequently as required by law  
    (once per year at a minimum), and forwards results to the GM.<br/>
    工程部和保安部要按当地规定，完善定期消防训练，至少一年一次，相关报告交由总经理审阅。
    `,
    file: "消防演习报告",
    control: "",
}, {
    sort: 54,
    name: "IT",
    risks: `4`,
    file: "",
    control: "",
}, {
    sort: 55,
    name: "0",
    risks: `Associate exit policy exists in hotel.<br/>
    酒店员工离职制度，以及相关的信息备份和保护。
    `,
    file: "",
    control: "",
}, {
    sort: 56,
    name: "0",
    risks: `All systems passwords updated. Information integrity maintained. Confidential information,  
    personally identifiable information, and credit card information is properly protected.<br/>
    酒店所有系统的密码保护政策以及信息保存的完整性。正确保护机密信息，私人信息和信用卡信息。
    `,
    file: "",
    control: "",
}, {
    sort: 57,
    name: "0",
    risks: `Systems back-up performed by appointed systems manager regularly for PMS, accounting  
    system, POS and hotel server.<br/>
    电脑房应由专人按时做系统备份，如 管理系统，财务系统，收银系统及服务器。
    `,
    file: "",
    control: "",
}, {
    sort: 58,
    name: "0",
    risks: `Tapes stored at remote locations from CPU's.  (Indicate storage location)<br/>
    磁带存放处要远离 CPU，并指明存放处。
    `,
    file: "",
    control: "",
}, {
    sort: 59,
    name: "Total Hotel",
    risks: `4`,
    file: "",
    control: "",
}, {
    sort: 60,
    name: "0",
    risks: `The following up reports of Operating Equipments from every related department should be  
    reviewed by General Manager and taken action by hotel team on a quarterly basis.<br/>
    所有相关部门的营运工具盘点跟进报告由总经理审阅并由酒店团队每季度实施。
    `,
    file: "",
    control: "",
}, {
    sort: 61,
    name: "0",
    risks: `All Management / Lease Agreement provisions are adhered to. Owner reporting due dates and 
    format are strictly enforced. FF&E accounting is handled in accordance with the Agreement. 
    Minutes for all meetings are kept (Owners, finance, credit meetings).  Owner correspondence
    and customer correspondence is tracked appropriately.<br/>
    执行管理合同中的所有规定，严格执行业主所需报表的日期和内容，依照合同处理固定资产帐目， 
    保存所有会议纪要，与业主方和客人之间的往来信件需及时跟进。
    `,
    file: "",
    control: "",
}, {
    sort: 62,
    name: "0",
    risks: `Local Standard Operating Procedures are approved by the relevant disciplines and Vice 
    President - Operations before implementation. All approval must be filed in the hotels for the 
    inspection. <br/>
    所有酒店个体的标准操作流程需要由相关部门的运营副总裁审批后，方可实施。所有审批文件需及 
    时归档备查。
    `,
    file: "",
    control: "",
}, {
    sort: 63,
    name: "0",
    risks: `Self assessment audits of the Control Environment Diagnostic Tool are completed quarterly. 
    Compliance scores of Green, Yellow, Red ratings are assigned to managers.  General Manger 
    holds managers accountable for assessment scores.  Managers who achieve greens audits 
    are recognized and celebrated.  Self audits are completed and plans and actions exist for 
    identified weaknesses.  Plans and actions are updated and corrective measures are in place. 
    General Manager should be responsible for the final results.<br/>
    此检查表格为酒店每季度完善自我检查工具，执行分数（绿色，黄色和红色）需要指定到相关管理
    人员，总经理应掌握负责评分的管理人员，达到绿色分数的管理人员应鼓励。通过自我检查，可以
    对目前不足之出进行整改，以确保改进措施行之有效。总经理应对最终的结果负责。
    `,
    file: "",
    control: "",
}];


export const dataInputDefault = [{
    name: "Audited by Director of Finance / Date:",
    value: ""
}, {
    name: "Reviewed / signed by General Manager / Date: ",
    value: ""
}];


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-10/data.js